<template>
  <section class="authentication-form">
    <div class="innerpage-decor">
      <div class="innerpage-circle1">
        <img
          src="../assets/images/Testimonial2.png"
          alt=""
        >
      </div>
      <div class="innerpage-circle2">
        <img
          src="../assets/images/Testimonial1.png"
          alt=""
        >
      </div>
    </div>
    <!-- About Start  -->
    <DetailsForm />
    <!-- About End -->
  </section>
</template>

<script>
export default {
  name: 'AfterSignIn',
  mounted() {
    document.querySelector('.navbar').classList.add('darkHeader')
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/after_sign_up.vue